export enum HeadQuarterBranchFilterEnum {
  All = 1,
  Only_Headquarters = 2,
  Only_Branches = 3
}
